import { OneVerifyApplicationRole } from "@common-shared/config/rolesPermissions.config.ts"

import type { ISelectRenderedOption } from "@front-shared/types/objects.types.ts"

export const ROLES_PERMISSIONS_CONFIG = {
    inviteRenderedRoles: [
        {
            value: OneVerifyApplicationRole.practiceAdmin,
            displayValue: "Admin",
            dropdownDisplayValue: "Admin",
        },
        {
            value: OneVerifyApplicationRole.practiceBiller,
            displayValue: "Biller",
            dropdownDisplayValue: "Biller",
        },
    ] as ISelectRenderedOption[],
}
